import React from 'react';
import { Link } from 'react-router-dom';
import { MdClose as CloseIcon, MdInfoOutline } from '../../Common/Icons';
import './Alert.css';
import { t } from 'i18next';

export default ({
  title = '',
  className = '',
  id = '',
  // autoFocus = false,
  // ref = '',
  children,
  linkTo = '',
  onClickHandler,
  crossIcon = true,
}) => (
  <div className={`alert ${className}`} id={`${id}`} tabIndex="-1">
    <div className="alert--title">
      <span className="d-flex align-center">
        <MdInfoOutline className="alert--search-icon" />
        <span>{title}</span>
      </span>
      {linkTo ? (
        <Link to={linkTo}>
          {title !== t('elastic_search_alert.search_criteria') && crossIcon ? (
            <CloseIcon />
          ) : (
            <u> {t('elastic_search_alert.clear_search')} </u>
          )}
        </Link>
      ) : (
        <button className="button" onClick={onClickHandler}>
          {title !== t('elastic_search_alert.search_criteria') ? (
            <CloseIcon />
          ) : (
            <u> {t('elastic_search_alert.clear_search')} </u>
          )}
        </button>
      )}
    </div>
    <div className="alert--body">{children}</div>
  </div>
);
